import {Component, input, InputSignal} from '@angular/core';
import {TranslatePipe} from "@ngx-translate/core";

@Component({
  selector: 'app-object-view-section-title',
  imports: [
    TranslatePipe,
  ],
  templateUrl: './object-view-section-title.component.html',
  styleUrl: './object-view-section-title.component.scss'
})
export class ObjectViewSectionTitleComponent {
  title: InputSignal<string> = input('');
}
